// English strings (source language): ongoing race and workout (HUD, pause menu, end screen).

const en = {
  // HUD and scenery
  halfway: 'HALFWAY',
  grade: 'grade',
  resistance: 'resistance',
  draft: 'draft',
  draftBanner: '≋ drafting ≋',
  menuTitle: 'Menu (Esc)',
  /** Performance overlay units and labels (perf.ts). */
  perf: { fps: 'fps', sim: 'sim', hud: 'hud', draw: 'draw', calls: 'calls', tris: 'tris', tex: 'tex', prog: 'shaders', net: 'net', snaps: 'snap/s', riders: 'riders' },
  go: 'GO!',
  pct: (v: string) => `${v}%`,
  rankOf: (n: number) => `/ ${n}`,
  lap: (lap: number, laps: number) => `Lap ${lap} / ${laps}`,
  elimLap: (lap: number, left: number) => `Lap ${lap} · ${left} left`,
  remaining: (time: string) => `${time} left`,
  slotHint: (ride: boolean) => (ride ? 'power-up button · ' : '') + 'Space',
  gap: 'gap',
  teams: 'Teams',
  you: (rank: number) => `you ${rank}`,
  out: 'out',
  free: 'Free',
  workoutDone: 'Workout complete!',
  next: (what: string, dur: string) => `Next: ${what} for ${dur}`,
  nextFree: 'free ride',
  lastBlock: 'Last block',
  compliance: 'compliance',
  ergOff: 'ERG off',
  ergNone: 'ERG unavailable',
  simulated: (w: number) => `Simulated mode: ${w} W (↑ ↓ arrows)`,
  noTrainer: 'No trainer: connect a smart trainer or a power meter in Connections to ride',
  noData: 'No data from the trainer: pedal!',
  playersOnline: (n: number) => `🌐 ${n} player${n === 1 ? '' : 's'} online`,
  /** Spectator view (ride/spectate.ts). */
  spectate: {
    title: 'Supporter',
    prev: 'Previous rider',
    next: 'Next rider',
    auto: 'Automatic director: follows the action',
    autoShort: 'TV',
    shots: { chase: 'Chase', heli: 'Helicopter', side: 'Side', front: 'Front', onboard: 'Onboard' },
    cheers: { go: 'Go!', fire: 'On fire', clap: 'Bravo', horn: 'Horn', heart: 'Love', wow: 'Wow' },
    cheerHelp: 'Everyone sees and hears your cheers. The rider you cheer gets a small crowd boost, at most once every 20 seconds whatever the number of supporters.',
    boostOff: 'Cheers are seen and heard only: no crowd boost in this race.',
    chatPlaceholder: 'Say something to the riders…',
    chatClosed: 'The host closed the chat to supporters.',
    mutedByHost: 'The host muted you: no chat or cheers for now.',
    supporters: (n: number) => `${n} supporter${n === 1 ? '' : 's'}`,
    keys: { riders: 'rider', shots: 'camera', auto: 'TV director', cheer: 'cheers', chat: 'chat' },
    menuHelp: 'The race goes on while this menu is open.',
    leave: 'Stop watching',
    over: 'Race over',
    cheersSeen: (n: number) => `${n} cheer${n === 1 ? '' : 's'} from the supporters.`,
    backToRoom: 'Back to the room',
  },
  // Loading and pause menu
  building: 'Building the course…',
  buildingHelp: 'Terrain, trees, crowd: a few seconds.',
  onlineRace: 'Online race',
  pause: 'Paused',
  onlineHelp: 'The race keeps going while this menu is open.',
  pauseHelp: 'Trainer resistance has been reset to flat.',
  keys: { lane: 'move across the road', item: 'item', gears: 'gears', watts: 'simulated watts', look: 'look back', camera: 'change view', intensity: 'intensity', next: 'next block' },
  viewChanged: (name: string) => `View: ${name}`,
  finishSave: 'Finish and save',
  abandon: 'Quit race',
  backToRace: 'Back to the race',
  resume: 'Resume',
  // End screen
  finished: 'Finished',
  workoutCompleted: 'Workout complete, well done!',
  workoutStopped: 'Workout stopped.',
  ghostAbandoned: 'Time trial abandoned',
  ghostTag: 'Ghost',
  firstTime: (time: string) => `First time: ${time}`,
  newRecord: (time: string) => `🏆 New record: ${time}`,
  betterBy: (secs: string) => `${secs} s faster than your previous record`,
  recordWas: (time: string, secs: string) => `Record: ${time} (+${secs} s)`,
  freeDone: '🚴 Free ride finished',
  raceAbandoned: 'Race abandoned',
  victory: '🏆 Victory!',
  rankOutOf: (rank: string, n: number) => `${rank} of ${n}`,
  ftpTitle: 'Your FTP',
  ftpUp: (w: number) => `Up from ${w} W`,
  ftpDown: (w: number) => `Down from ${w} W`,
  ftpSame: 'Unchanged',
  ftpFollows: 'Workout targets, zones and bots follow it from now on.',
  ftpRise: { first: 'Your FTP is measured', best: 'New best FTP', up: 'FTP up' },
  ftpGain: (w: number, pct: string) => `+${w} W · +${pct} %`,
  ftpWas: (w: number) => `was ${w} W`,
  ftpMilestone: (wkg: string) => `Past ${wkg} W/kg`,
  rider: 'Rider',
  team: 'Team',
  riders: 'Riders',
  teamTime: 'Team time',
  teamVictory: (team: string) => `🏆 ${team} wins!`,
  teamRankOutOf: (team: string, rank: string, n: number) => `${team}: ${rank} of ${n} teams`,
  hits: 'Hits',
  time: 'Time',
  distance: 'Distance',
  duration: 'Duration',
  average: (np: number) => `Average · NP ${np} W`,
  tss: (f: string) => `TSS · IF ${f}`,
  tooShort: 'Activity too short: nothing was saved.',
  levelUp: 'LEVEL UP',
  level: (n: number) => `Level ${n}`,
  unlocked: '🔓 Unlocked',
  achievements: '🏅 Achievements',
  offlineSaved: '⚠️ Server unreachable: the activity is kept here and will be sent at the next sync.',
  viewActivity: 'View activity',
  eventStandings: 'Event standings',
  replay: 'Play again',
  watchReplay: 'Watch the replay',
  continue: 'Continue',
};
export default en;
